import api from "./en-US/api";
import appName from "./en-US/appName";
import attendanceCards from "./en-US/attendanceCards";
import attendanceOptions from "./en-US/attendanceOptions";
import attendanceTypes from "./en-US/attendanceTypes";
import auth from "./en-US/auth";
import billing from "./en-US/billing";
import chat from "./en-US/chat";
import common from "./en-US/common";
import contacts from "./en-US/contacts";
import dashboard from "./en-US/dashboard";
import displayMessages from "./en-US/displayMessages";
import eventTimeline from "./en-US/eventTimeline";
import financial from "./en-US/financial";
import functions from "./en-US/functions";
import guides from "./en-US/guides";
import home from "./en-US/home";
import import_ from "./en-US/import";
import journeyStages from "./en-US/journeyStages";
import landing from "./en-US/landing";
import landingHome from "./en-US/landingHome";
import memberGroup from "./en-US/memberGroup";
import memberHistory from "./en-US/memberHistory";
import membersAssignments from "./en-US/membersAssignments";
import mfa from "./en-US/mfa";
import menu from "./en-US/menu";
import navigation from "./en-US/navigation";
import notFound from "./en-US/notFound";
import onboarding from "./en-US/onboarding";
import orixas from "./en-US/orixas";
import pagination from "./en-US/pagination";
import people from "./en-US/people";
import personGuides from "./en-US/personGuides";
import personMessage from "./en-US/personMessage";
import personReturn from "./en-US/personReturn";
import persons from "./en-US/persons";
import profile from "./en-US/profile";
import registerInvite from "./en-US/registerInvite";
import registerTemple from "./en-US/registerTemple";
import reports from "./en-US/reports";
import ritualAttendance from "./en-US/ritualAttendance";
import ritualClosing from "./en-US/ritualClosing";
import ritualTypes from "./en-US/ritualTypes";
import rituals from "./en-US/rituals";
import ritualReservations from "./en-US/ritualReservations";
import spiritualLines from "./en-US/spiritualLines";
import support from "./en-US/support";
import table from "./en-US/table";
import temple from "./en-US/temple";
import agendaPublica from "./en-US/agendaPublica";
import themes from "./en-US/themes";
import ticketCall from "./en-US/ticketCall";
import tickets from "./en-US/tickets";
import tours from "./en-US/tours";
import users from "./en-US/users";
import ownershipTransfer from "./en-US/ownershipTransfer";
import validation from "./en-US/validation";
import phoneField from "./en-US/phoneField";
import verifyEmail from "./en-US/verifyEmail";
import wisdomQuotes from "./en-US/wisdomQuotes";
import session from "./en-US/session";

export default {
	relatedEntityCreation: {
		createSpiritualLine: "+ Create Spiritual Line",
		createGuide: "+ Create Guide",
		createAttendanceType: "+ Create Attendance Type",
		createRitualType: "+ Create Ritual Type",
		createMedium: "+ Create Medium",
	},
	appName,
	api,
	attendanceCards,
	attendanceOptions,
	attendanceTypes,
	auth,
	billing,
	chat,
	common,
	contacts,
	dashboard,
	displayMessages,
	eventTimeline,
	financial,
	functions,
	guides,
	home,
	import: import_,
	journeyStages,
	landing,
	landingHome,
	memberGroup,
	memberHistory,
	membersAssignments,
	mfa,
	menu,
	navigation,
	notFound,
	onboarding,
	orixas,
	pagination,
	people,
	personGuides,
	personMessage,
	personReturn,
	persons,
	profile,
	registerInvite,
	registerTemple,
	reports,
	ritualAttendance,
	ritualClosing,
	ritualTypes,
	rituals,
	ritualReservations,
	spiritualLines,
	support,
	table,
	temple,
	agendaPublica,
	themes,
	ticketCall,
	tickets,
	tours,
	users,
	ownershipTransfer,
	validation,
	phoneField,
	verifyEmail,
	wisdomQuotes,
	session,
};
